module.exports = "<span data-ng-message=required>*At least one selection is required.</span> ";